// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"ef66ddd45525cf7d","925":"b425f85f4be026b6"}[chunkId] + ".js";
};